import "preact/debug";
import { Fragment, h, render } from "preact";
import Router, { route } from "preact-router";
import { DefaultPage } from "./components/defaultpage";
import { ProductPage } from "./components/productpage";
import { CategoryPage } from "./components/categorypage";
import { ShoppingBasket } from "./components/shoppingbasket";
import { useShoppingBasketPersistence } from "./services/shoppingbasket";
import { CheckoutPage } from "./components/checkoutpage";
import { useData } from "./services/data";
import { Spinner } from "./components/spinner";
import { getCategoryUrl } from "./services/navigation";
import { ConfirmationPage } from "./components/confirmationpage";
import { useResizeObserverEffect } from "./hooks/useResizeObserver";
import "./material/material.scss";
import "./index.scss";
import { useBodyStyle } from "./hooks";

export function ClientApp() {
    useShoppingBasketPersistence();
    const data = useData();

    useBodyStyle(window !== window.top ? "isframed" : "isnotframed");

    useResizeObserverEffect(document.body, rect => {
        if(window !== window.top) {
            window.parent?.postMessage({
                type: "rentomatic-resize",
                height: document.body.scrollHeight
            }, "*");
        }
    });

    if (!data.ready) {
        return <Spinner />
    }

    if (document.location.pathname == "/") {
        document.location.replace(getCategoryUrl(data.categories[0]));
        return <Spinner />
    }

    return (
        <div class="layout">
            <div>
                <Router>
                    <ConfirmationPage path="/confirmation" />
                    <CheckoutPage path="/checkout" />
                    <CategoryPage path="/c/:id/:slug" />
                    <CategoryPage path="/c/:id" />
                    <ProductPage path="/p/:id/:slug" />
                    <ProductPage path="/p/:id" />
                    <DefaultPage path="/" default />
                </Router>
            </div>
            <ShoppingBasket />
        </div>
    );
}

if (window !== window.top) {
    console.log("We're inside a frame/iframe");
} else {
    console.log("We're in the top-level window");
}

const target = document.getElementById("root") as HTMLElement;
render(<ClientApp />, target);
